export enum REPORT_AI_SUMMARY_TYPES {
    SHORT = 'short',
    LONG = 'long',
}
